module.exports = __webpack_public_path__ + "img/activeicon-kvdr.85023eca.svg";